import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "money-dollar-16", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", stroke: "currentColor", strokeLinecap: "round", strokeWidth: 1.5 },
        React.createElement("path", { strokeLinejoin: "round", d: "M8 13v1.5M8 2v2" }),
        React.createElement("path", { d: "M12 6a1.75 1.75 0 0 0-1.75-1.75H6a2 2 0 1 0 0 4h4a2 2 0 1 1 0 4H5.75A1.75 1.75 0 0 1 4 10.5h0" })));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
